<template>
  <BreadCrumb PageTitle="Nouveau Produit" />
  <AddProduct />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AddProduct from "../../components/Stock/AddProduct.vue";

export default defineComponent({
  name: "AddProductPage",
  components: {
    BreadCrumb,
    AddProduct,
  },
});
</script>